module.exports = __webpack_public_path__ + "img/btn_confirm.1be9a784.png";